export const getISTDate = () => {
  // Get current time in IST
  const now = new Date();
  const istOffset = 5.5 * 60 * 60 * 1000;
  const utc = now.getTime() + now.getTimezoneOffset() * 60 * 1000;
  const istDate = new Date(utc + istOffset);

  // Extract the IST date parts
  const year = istDate.getFullYear();
  const month = istDate.getMonth();
  const day = istDate.getDate();

  // ✅ Return as LOCAL midnight — so calendar always shows the right date
  return new Date(year, month, day, 0, 0, 0, 0);
};
